export const mainPalette = [
  ['#FFFFFF', '#F0F0F0', '#C7C7C7', '#757575', '#000000'],
  ['#C3B0FF', '#9878FF', '#7247FF', '#542ED0', '#311788'],
  ['#FFCAFA', '#F28DE8', '#ED24D9', '#9E1891', '#4F0C48'],
  ['#D5F4F4', '#81DFE0', '#7247FF', '#00848E', '#00474B'],
  ['#FFEFD8', '#FFD187', '#F7A502', '#D78302', '#835401'],
];

export const mainPaletteInverted = [
  ['#000000', '#757575', '#C7C7C7', '#F0F0F0', '#FFFFFF'],
  ['#311788', '#542ED0', '#7247FF', '#9878FF', '#C3B0FF'],
  ['#4F0C48', '#9E1891', '#ED24D9', '#F28DE8', '#FFCAFA'],
  ['#00474B', '#00848E', '#7247FF', '#81DFE0', '#D5F4F4'],
  ['#835401', '#D78302', '#F7A502', '#FFD187', '#FFEFD8'],
];

export const secondaryPalette = [
  ['#FFFFFF', '#F0F0F0', '#C7C7C7', '#757575', '#000000'],
  ['#AECBFF', '#5F98FC', '#1A66EB', '#144AA9', '#092351'],
  ['#BAFFEF', '#7BE2CA', '#55B8A1', '#28816C', '#28584D'],
  ['#C1F6B0', '#94D381', '#5B9E46', '#3F712F', '#395203'],
  ['#FFF8BB', '#EFE47F', '#E2CE16', '#CDBB10', '#7A7008'],
];

export const secondaryPaletteInverted = [
  ['#000000', '#757575', '#C7C7C7', '#F0F0F0', '#FFFFFF'],
  ['#092351', '#144AA9', '#1A66EB', '#5F98FC', '#AECBFF'],
  ['#28584D', '#28816C', '#55B8A1', '#7BE2CA', '#BAFFEF'],
  ['#395203', '#3F712F', '#5B9E46', '#94D381', '#C1F6B0'],
  ['#7A7008', '#CDBB10', '#E2CE16', '#EFE47F', '#FFF8BB'],
];

export const palettes = [
  mainPalette,
  mainPaletteInverted,
  secondaryPalette,
  secondaryPaletteInverted,
];

export function colorNameToPosition(colorName: string): {
  row: number;
  col: number;
} {
  let pos = null;

  if (colorName.startsWith('color-')) {
    const index = parseInt(colorName.split('-')[1], 10) - 1;
    pos = {
      row: index % 5,
      col: Math.floor(index / 5),
    };
  }

  return pos;
}

export const STATIC_COLORS = { errorColor: '#DF3131', successColor: '#008250' };
